/* eslint-disable @typescript-eslint/no-this-alias */
import React, {useEffect, useState} from 'react';
import Skeleton from '@mui/material/Skeleton';
import BillingAddressCard from './BillingAddressCard.jsx';

const BillingAddressContainer = ({
	col = null,
	context = 'myspace',
	membres_id = 0,
	connected_as ='providers'
}) => {
	const finalCol = col ? parseInt(col) : 3

	const [isLoading, setIsLoading] = useState(true);
	const [billingAddresses, setBillingAddresses] = useState([]);

	const url = context == 'congress' ? (ENV.base_lang_url + "account/ajax_billing_address/get_list/null/" + membres_id) : (ENV.base_lang_url+"myspace/" + connected_as + "//ajaxGetter/get_billing_addresses_by_membres")

	useEffect(() => {
		const params = new URLSearchParams();
		params.append('membres_id', membres_id);

		fetch(url, { 
			method: 'POST',
			headers:  { "Content-Type": "application/x-www-form-urlencoded" },
			body: params.toString()
		})
		.then(res => res.json())
		.then(
			(result) => {
				setIsLoading(false);
				setBillingAddresses(result.billingAddresses);
			}
		)		
	}, [])

	const handleDelete = id => {
		const billingAddressesNew = billingAddresses;
		const index = billingAddressesNew.findIndex(billingAddress => billingAddress.id === id);

		billingAddressesNew.splice(index, 1);

		bootbox.confirm({
			message: 'alert_delete_billing_address'.trad(),
			centerVertical: true,
			callback: function (result) {
				if (result) {

					$.ajax({
						type: "POST",
						url: context == 'congress' ?
							ENV.base_lang_url + "account/ajax_billing_address/delete/" + id + "/" + membres_id
							:
							ENV.base_lang_url + "myspace/" + connected_as + "//account/ajax_billing_address/delete/" + id + "/" + membres_id,
						dataType: 'json',
						success: function (data) {
							if (data.success) {
								setBillingAddresses(billingAddressesNew);
							} else {
								nav.infos_error('delete_error'.trad());
							}
						}
					});

				}
			},
			buttons: {
				confirm: {
					label: 'yes'.trad(),
					className: 'btn-orange font-weight-bold'
				},
				cancel: {
					label: 'no'.trad(),
					className: 'btn-light font-weight-bold'
				}
			}
		});
	}

	const handleDefineAsDefault = id => {
		const billingAddressesNew = [...billingAddresses];
		const index = billingAddressesNew.findIndex(billingAddress => billingAddress.id === id);
		const indexDefault = billingAddressesNew.findIndex(billingAddress => billingAddress.is_default === '1');

		if (indexDefault !== -1) {
			billingAddressesNew[indexDefault] = { ...billingAddressesNew[indexDefault], is_default: '0' };
		}

		billingAddressesNew[index] = { ...billingAddressesNew[index], is_default: '1' };

		setBillingAddresses(billingAddressesNew)

		$.ajax({
			type: "POST",
			url: context == 'congress' ?
				ENV.base_lang_url + "account/ajax_billing_address/set_default/" + id + "/" + membres_id
				:
				ENV.base_lang_url + "myspace/" + connected_as + "//account/ajax_billing_address/set_default/" + id + "/" + membres_id,
			dataType: 'json',
			success: function (data) {
				if (data.success) {
					// setBillingAddresses(billingAddressesNew)
				}
			}
		});
	}

	return (
		<div className="row">
			{isLoading ?
				<div className={"billing-address-card col-12 col-md-6 mb-4 " + (finalCol == 2 ? "col-xl-6" : "col-xl-4")}>
					<Skeleton className="card" variant="rectangular" width="100%" height={360} />
				</div>
				:
				(billingAddresses.length > 0 ?
					billingAddresses.map((e, index) =>
						<BillingAddressCard
							id={e.id}
							key={index}
							cardTitle={e.name}
							businessName={e.business_name}
							lastName={e.business_holder_last_name}
							firstName={e.business_holder_first_name}
							address={e.business_address}
							postalCode={e.business_postal_code}
							city={e.business_city}
							country={e.title}
							taxId={e.business_tax_id}
							isDefault={e.is_default ?? null}
							onDelete={handleDelete}
							onDefineAsDefault={handleDefineAsDefault}
							col={finalCol}
							context={context}
							connected_as={connected_as}
							membres_id={membres_id}
						/>)
					:
					<div className="col-12 text-center my-5"><p>{'aucune_adresse'.trad()}</p></div>
				)
			}
		</div>
	)
}

export default BillingAddressContainer;